import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private activeRequests = 0;

  constructor(private spinnerService:NgxSpinnerService) { }

  llamarSpinner(){
    if (this.activeRequests === 0) {
      this.spinnerService.show();
    }
    this.activeRequests++;
  }

  detenerSpinner(){
    this.activeRequests--;
    if (this.activeRequests === 0) {
      this.spinnerService.hide();
    }
  }
}
